// extracted by mini-css-extract-plugin
export default {"contactProfessionSearchItem":"ContactsProfessionSearch_contactProfessionSearchItem__ErmlG"};